<p-panel>
    <p-header>
        <label i18n="@@labelHeaderText2">Resumo</label>
     </p-header>
    <form>
      <div class="ui-g">
          <div class = "ui-grid ui-grid-responsivo fluido-ui">
            <div class = "ui-grid-row">
              <div class="ui-grid-col-1"> </div>
              <div class="ui-grid-col-6">
                <label i18n="@@labelText9" for="cliente" class="fa-col-form-label">Cliente</label>
              </div>
              <input pInputText id="cliente" type="text" value="{{pedido.cliente.nomeTitular}}" class="ui-grid-col-12" disabled />
            </div>
            <br />
            <div class = "ui-grid-row"  *ngIf="pedido.ativo">
                <div class="ui-grid-col-1"> </div>
                <div class="ui-grid-col-6">
                    <label for="ativo" class="fa-col-form-label">Ativo</label>
                </div>
                <input pInputText id="ativo" 
                       type="text" 
                       value="{{descricaoAtivo}}" class="ui-grid-col-12" disabled />
            </div>
            <br />
            <div class = "ui-grid-row">
              <div class="ui-grid-col-1"> </div>
              <div class="ui-grid-col-6">
                  <label i18n="@@labelText10" for="endereco">Endereço</label>
              </div>
                <input pInputText id="endereco" type="text" value="{{pedido.endereco.enderecoCompleto}}" class="ui-grid-col-12" disabled />
            </div>
            <br />
            <br />
            <div class = "ui-grid-row" *ngIf="pedido.ambientes.length > 0">
                <div class="ui-grid-col-1"> </div>
                <div class="ui-grid-col-6">
                  <label i18n="@@labelText86">Ambientes</label>
                </div>
                <p-listbox [options]="pedido.ambientes" disabled="true" optionLabel="descricao" class="ui-grid-col-12"></p-listbox>
            </div>
            <br />
            <br />
            <div class = "ui-grid-row">
                <div class="ui-grid-col-1"> </div>
                <div class="ui-grid-col-6">
                    <label i18n="@@labelText11" for="tipoOS">Tipo de Serviço</label>
                </div>
                  <input pInputText id="tipoOS" type="text" value="{{pedido.tipoOS.resumoTipoOs}}" class="ui-grid-col-12" disabled/>
              </div>
              <br />
              <div class = "ui-grid-row">
                  <div class="ui-grid-col-1"> </div>
                  <div class="ui-grid-col-6">
                      <label i18n="@@labelText12" for="observacao">Observação</label>
                  </div>
                    <textarea pInputTextarea id="observacao" 
                              type="text" 
                              i18n-placeholder
                              placeholder="Observação..." 
                              [rows]="5" 
                              [cols]="100" 
                              autoResize="autoResize" 
                              class="ui-grid-col-12"
                              [(ngModel)]="osIn.observacao"
                            name="observacao"></textarea>
              </div>
              <br />
            </div>
        </div>
      </form>
</p-panel>
